module.exports = __webpack_public_path__ + "static/media/bg-slim-button.601db8de.png";